import React, { useContext } from "react";
import Consultants from "./Consultants";
import { AuthContext } from "../context/AuthContext";
import { useHistory } from "react-router-dom";

const Home = () => {
  const authContext = useContext(AuthContext);
  const history = useHistory();

  if (
    authContext.user.role.includes("admin") ||
    authContext.user.role.includes("user")
  ) {
    return <Consultants />;
  }
  return (
    <div style={{ textAlign: "center", marginTop: "15%" }}>
      <h1>Welcome to Drakryggen´s consultant portal</h1>
      <h4>
        <span
          style={{ color: "red", cursor: "pointer" }}
          onClick={() => history.push(`/login/`)}
        >
          Login
        </span>{" "}
        to manage your account or to review consultant profiles
      </h4>
    </div>
  );
};

export default Home;
